import { render, staticRenderFns } from "./FeedbackSupplement.vue?vue&type=template&id=336ba877&scoped=true"
import script from "./FeedbackSupplement.vue?vue&type=script&lang=js"
export * from "./FeedbackSupplement.vue?vue&type=script&lang=js"
import style0 from "./FeedbackSupplement.vue?vue&type=style&index=0&id=336ba877&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336ba877",
  null
  
)

export default component.exports